module.exports = __webpack_public_path__ + "static/media/a-1-b.cb2c006c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-1-b.jpg
// module id = 1089
// module chunks = 33